export default __webpack_public_path__ + "static/media/step - 1.fc7b0481.jpeg";